<template>
	<button
		class="clear-filters"
		@click="$emit('clear')"
	>
		<i class="fas fa-trash" />
		{{ $t('clearFilters') }}
	</button>
</template>

<script>
export default {
	name: 'ClearFiltersButton',
}
</script>

<style scoped>
.clear-filters {
	display: flex;
	align-items: center;
	border: none;
	background: none;
	color: #d32f2f;
	font-size: 14px;
	cursor: pointer;
}

.clear-filters i {
	margin-right: 5px;
}
</style>
